import { LocationDto } from "@/core/api/generated/v1";

import BaseEntityAutocompleteOrCreate, {
  AutocompleteType,
  BaseEntityAutocompleteOrCreateInheritableProps,
} from "../components/BaseEntityAutocompleteOrCreate";
import LocationAutocomplete, { LocationAutocompleteProps } from "./LocationAutocomplete";
import LocationCreateUpdate, { LocationCreateUpdateProps } from "./LocationCreateUpdate";
import LocationCreateUpdateModal from "./LocationCreateUpdateModal";

type Props = BaseEntityAutocompleteOrCreateInheritableProps<
  LocationDto,
  LocationCreateUpdateProps["defaultValues"],
  LocationAutocompleteProps,
  Pick<LocationCreateUpdateProps, "defaultValues">
>;

export default function LocationAutocompleteOrCreate({ ...otherProps }: Props) {
  return (
    <BaseEntityAutocompleteOrCreate<
      LocationDto,
      LocationCreateUpdateProps["defaultValues"],
      LocationAutocompleteProps,
      Pick<LocationCreateUpdateProps, "defaultValues">
    >
      autocompleteType={AutocompleteType.Single}
      getDefaultValues={(params) => params.createUpdateProps?.defaultValues}
      renderAutocomplete={(params) => (
        <LocationAutocomplete
          {...params.autocompleteProps}
          withCreate
          createOptionTitle={(inputValue) => `Create new location "${inputValue}"`}
          onCreate={(newOption) => {
            params.setDefaultValues({
              ...params.defaultValues,
              name: newOption?.inputValue || params.defaultValues?.name || undefined,
            });
            params.setIsCreate(true);
            params.onCreateStart && params.onCreateStart();
          }}
        />
      )}
      renderCreateUpdate={(params) => (
        <LocationCreateUpdate
          {...params.createUpdateProps}
          defaultValues={params.defaultValues}
          onCreate={params.onCreate}
          onSave={(newValue) => {
            params.setIsCreate(false);
          }}
        />
      )}
      renderCreateUpdateModal={(params) => (
        <LocationCreateUpdateModal
          open={params.isCreate}
          onClose={() => params.setIsCreate(false)}
          createUpdateProps={{
            ...params.createUpdateProps,
            defaultValues: params.defaultValues,
            onCreate: params.onCreate,
            onSave: (newValue) => {
              params.setIsCreate(false);
            },
          }}
        />
      )}
      {...otherProps}
    />
  );
}
